import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToasterItemComponent } from '@shared/components/toaster/components/toaster-item/toaster-item.component';
import { ToasterModel } from '@shared/components/toaster/toaster.model';
import { ToasterService } from '@shared/components/toaster/toaster.service';

@Component({
  selector: 'toaster-list',
  standalone: true,
  imports: [CommonModule, ToasterItemComponent],
  templateUrl: './toaster-list.component.html',
  styleUrl: './toaster-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterListComponent {
  toasters$ = this.toasterService.toasters$;

  constructor(private toasterService: ToasterService) {}

  trackById(index: number, toaster: ToasterModel): string {
    return toaster.id ?? index.toString();
  }
}
